import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { get } from 'lodash';
import { fromJS } from 'immutable';
import { getE164NumberInRunUrlFriendlyFormat, getNumberInRunUrlFriendlyFormat, populateUrl } from 'flow/utils/run-url-utils';
export var VARIABLE_MISSING_VALUE = '-';
var NON_REPLACEMENT_KEYS = ['secondaryLabel'];
var URL_KEYS = ['actionUrl'];
var _buildWidgetDataFromConfig = function buildWidgetDataFromConfig(config, variables) {
  config = config || {};
  variables = variables || {};
  var keys = Object.keys(config);
  var formattedConfig = Array.isArray(config) ? [] : {};
  keys.forEach(function (key) {
    var value = config[key];
    if (NON_REPLACEMENT_KEYS.includes(key)) {
      formattedConfig[key] = value;
    } else if (URL_KEYS.includes(key)) {
      formattedConfig[key] = populateUrl(value, variables);
    } else if (typeof value === 'string') {
      formattedConfig[key] = formatOther(value, variables);
    } else if (/*#__PURE__*/React.isValidElement(value)) {
      formattedConfig[key] = value;
    } else if (_typeof(value) === 'object' && value) {
      formattedConfig[key] = _buildWidgetDataFromConfig(value, variables);
    } else {
      formattedConfig[key] = value;
    }
  });
  return formattedConfig;
};
export { _buildWidgetDataFromConfig as buildWidgetDataFromConfig };
export var formatDiscriminator = function formatDiscriminator() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var substituteDiscriminator = substituteString(true);
  getKeysFromString(string).forEach(function (key) {
    var value = get(variables, key, '');
    if (key) {
      string = substituteDiscriminator(string, key, value);
    }
  });
  return string;
};
export var formatOther = function formatOther() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var substituteOther = substituteString(false);
  getKeysFromString(string).forEach(function (key) {
    var value = get(variables, key, '');
    if (key) {
      string = substituteOther(string, key, value);
    }
  });
  return string;
};
export var getKeysFromString = function getKeysFromString() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var braceDelimiters = string.includes('{');
  var matchResults = braceDelimiters ? string.matchAll(/{(.*?)}/g) : string.matchAll(/%(.*?)%/g);
  var keys = [];
  var _iterator = _createForOfIteratorHelper(matchResults),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var matchResult = _step.value;
      keys.push(matchResult[1]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return keys;
};
export var substituteString = function substituteString(isDiscriminator) {
  return function (string, key, value) {
    var braceDelimiters = string.includes('{');
    var startDelimiter = braceDelimiters ? '{' : '%';
    var endDelimiter = braceDelimiters ? '}' : '%';
    return isDiscriminator ? substituteDiscriminator(string, startDelimiter, key, endDelimiter, value) : substituteOther(string, startDelimiter, key, endDelimiter, value);
  };
};
var substituteDiscriminator = function substituteDiscriminator(string, startDelimiter, key, endDelimiter, value) {
  return value ? string.replace("".concat(startDelimiter).concat(key).concat(endDelimiter), value) : VARIABLE_MISSING_VALUE;
};
var substituteOther = function substituteOther(string, startDelimiter, key, endDelimiter, value) {
  return string.replace("".concat(startDelimiter).concat(key).concat(endDelimiter), value).replace(/\s+/g, ' ');
};
export var getHistoricCallVariables = function getHistoricCallVariables(callRecord, ownCountryCode, ownNumber) {
  if (!callRecord) return {};
  var variables = {};
  var contact = callRecord.get('contact');
  var direction = callRecord.get('direction');
  var isIncoming = direction === 'incoming';
  var recordNumber = callRecord.getIn(['number', 'number']);
  var caller = isIncoming ? recordNumber : ownNumber;
  var callee = isIncoming ? ownNumber : recordNumber;
  variables['CONTACT'] = contact ? parseMetadata(contact).toJS() : contact;
  variables['NUMBER'] = getNumberInRunUrlFriendlyFormat(caller, ownCountryCode);
  var intNumber = getE164NumberInRunUrlFriendlyFormat(caller, ownCountryCode);
  variables['INT-NUMBER'] = intNumber;
  variables['caller'] = intNumber;
  variables['B-NUMBER'] = getNumberInRunUrlFriendlyFormat(callee, ownCountryCode);
  variables['callee'] = getE164NumberInRunUrlFriendlyFormat(callee, ownCountryCode);
  variables['counterpart'] = getE164NumberInRunUrlFriendlyFormat(isIncoming ? caller : callee, ownCountryCode);
  return variables;
};
export var discriminatorIsPresent = function discriminatorIsPresent(discriminator, variables) {
  if (!discriminator) {
    // If the discriminator is undefined, we want to show the widget anyway
    return true;
  }
  var formattedDiscriminator = formatDiscriminator(discriminator, variables);
  return formattedDiscriminator !== VARIABLE_MISSING_VALUE;
};
export var chooseConfig = function chooseConfig(discriminator, variables, present, missing) {
  return discriminatorIsPresent(discriminator, variables) ? present : missing;
};
export var parseMetadata = function parseMetadata(contact) {
  if (!contact || typeof contact.get('metadata') !== 'string') {
    return contact;
  }
  try {
    return contact.set('metadata', fromJS(JSON.parse(contact.get('metadata'))));
  } catch (_e) {
    //do nothing
  }
  return contact;
};
export var isURL = function isURL(url) {
  try {
    new URL(url);
    return true;
  } catch (_error) {
    return false;
  }
};